<template>
  <div
    :class="
      $twMerge(
        'flex items-center gap-2 lg:gap-5 text-sm pl-6',
        props.appendClass,
      )
    "
  >
    <WrButton link="/contact-us" no-hover>Contact Us</WrButton>
    <ClientOnly>
      <div @click="toggleDarkMode">
        <WrButton
          no-hover
          container-class="overflow-hidden dark:bg-[linear-gradient(95.01deg,#BDB1FF_2.72%,#6952ED_95.35%)] rounded-full dark:p-px max-w-max bg-transparent bg-none px-0 py-0"
          append-class="h-full rounded-full border-0 dark:bg-[linear-gradient(95.99deg,#6C59B5_3.69%,#261640_96.65%)] !px-1 !py-1 lg:!px-2 lg:!py-2 bg-white bg-none"
        >
          <NuxtImg
            alt="themetoggle"
            :src="themeImg"
            width="24"
            height="24"
            loading="lazy"
            format="webp"
          />
        </WrButton>
      </div>
    </ClientOnly>

    <LazyWrMobileMegaMenu v-if="isMobile" class="lg:hidden" />
  </div>
</template>

<script setup lang="ts">
const { isMobile } = useDevice();
import { client } from "node:process";
import { computed } from "vue";
const { $twMerge } = useNuxtApp();
// const WrButton = defineAsyncComponent(() => import("~/components/global/WrButton.vue"));
const LazyWrMobileMegaMenu = defineAsyncComponent(
  () => import("~/components/molecules/WrMobileMegaMenu.vue"),
);
const { isDesktop } = useDevice();
const colorMode = useColorMode();

const themeImg = computed(() =>
  colorMode.preference === "dark"
    ? "/images/icons/sun.webp"
    : "/images/icons/sun-light.webp",
);

function toggleDarkMode() {
  colorMode.preference = colorMode.preference === "dark" ? "light" : "dark";
}

type Props = {
  appendClass?: string;
};
const props = withDefaults(defineProps<Props>(), {});
</script>
